import { cloneDeep, isEmpty } from 'lodash'

import { Services } from '@sigma-frontend-libs/commons'

import { BILLINGS_FILTER, dateFilter, minMax, sourceItems } from '@/utils'

import render from './render'

export default {
  name: 'Filters',

  mixins: [ dateFilter, minMax, sourceItems(Services.billings) ],

  mounted() {
    if (!isEmpty(this.$route.params)) {
      this.proxy.createdAt = this.$route.params.createdAt
    }
  },

  methods: {
    getDefaultFilter() {
      return cloneDeep(BILLINGS_FILTER)
    },

    clearFilter() {
      this.proxy = cloneDeep(this._inputFilter(this.getDefaultFilter()))
    }
  },

  render
}
